<div
  class="ui attached segment"
  appMargin
  marginT="5"
  style="border: 1px solid #dcdcdc; border-radius: 4px"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <!-- <div fxFlex="3%">
      <sui-checkbox> </sui-checkbox>
    </div> -->
    <div fxFlex="20">{{ department?.year }}</div>
    <div fxFlex="15">
      <div class="circle">
        {{ department?.networkOperatorCount }}
      </div>
    </div>
    <div fxFlex="15">
      <div class="circle">
        {{ department?.nonNetworkOperatorCount }}
      </div>
    </div>
    <div fxFlex="15">
      <div class="circle">
        {{ department?.documentCount }}
      </div>
    </div>
    <div fxFlex="15">
      <span
        class="ui gray circular label"
        [ngClass]="{
          green: department?.status === 'SUBMITTED',
          gray: department?.status == null
        }"
        >{{
          department?.status === "SUBMITTED" ? "SUBMITTED" : "NOT SUBMITTED"
        }}</span
      >
    </div>
    <div fxFlex="20%" class="text-right">
      <button
        (click)="nextPage.emit(department)"
        style="
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          color: #3f4395;
          width: 140px;
          height: 38px;
          background: #ffffff;
          border: 1px solid #3f4395;
          border-radius: 4px;
          cursor: pointer;
        "
      >
        Manage
      </button>
    </div>
  </div>
</div>
